import Vue from 'vue';

export function urlify(str) {
  return str.replace(/[ ]/g, '-').replace(/['.:!?()]/g, '').toLowerCase();
}

export function routesFromSections(sections) {
  const overviewRoutes = sections.map(section => ({ path: `/${section}`, component: Vue.component(section) }));
  const articleRoutes = sections.map(section => ({ path: `/${section}/:year/:month/:day/:title`, component: Vue.component(`${section}-entry`) }));
  return [...overviewRoutes, ...articleRoutes];
}
